export class ConvenioDadosAdicionaisModel {
    constructor(
        public odometro: string = '',
        public placa: string = '',
        public km: number = 0,
        public configuracaoIntegracao: string = '',
    ) { }
}